/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ForecastDuration {
    getFixupPrototypeFunction() { return ForecastDuration.fixupPrototype; }

    static newInstance(model: Partial<ForecastDuration>): ForecastDuration {
        let obj = Object.assign(new ForecastDuration(), model);
        ForecastDuration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ForecastDuration>): ForecastDuration {
        if (!model) return null;
        return ForecastDuration.newInstance(<ForecastDuration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ForecastDuration) {
        if (!obj) return;

        models.ForecastDuration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ForecastDuration): boolean {
        Object.setPrototypeOf(obj, ForecastDuration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.count === undefined) {
            this.count = 0;
        }
    }

    count: number;

    /**
     * Granularity to aggregate data
     */
    granularity: models.TrendGranularity;

}
